// Loads labels from DOM elements data-json into a collection.
// JSON must be structured as an object with props 'collectionName' and 'labels'.
import { useLabelsStore } from 'stores/labels.store'

export default function () {
    document.querySelectorAll('[data-labels]').forEach((element) => {
        const store = useLabelsStore()
        const data = JSON.parse(element.dataset.labels)
        store.setCollection(data)
    })
}
